// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2PMKV","inner":"Form_inner__oRGUf","range":"Form_range__18Fry","name":"Form_name__1C-Dz","actions":"Form_actions__2F9k7"};